import PropTypes from 'prop-types';
import { css, keyframes, styled } from 'styled-components';

const spin = keyframes`
  from {
    transform: rotate(0deg)
  }
  to {
    transform: rotate(360deg)
  }
`;

const animation = css`
  animation: ${spin} 2s linear infinite;
`;

const Spinner = styled.div`
  ${({ theme }) => css`
    position: absolute;
    border: 8px solid ${theme.colours.background.c};
    border-top: 8px solid ${theme.colours.link.default};
    border-radius: 50%;
    width: 40px;
    height: 40px;
    inset: 0;
    margin: auto;
    z-index: 9999;
  `};
  ${animation};
`;

const Loading = (props) => {
  const { loading } = props;
  if (loading) {
    return <Spinner>{loading}</Spinner>;
  }
  return null;
};

export default Loading;

Loading.propTypes = {
  loading: PropTypes.bool,
};
